<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 2C1 1.44771 1.44772 1 2 1H6.0001C6.55239 1 7.0001 1.44772 7.0001 2V6.0001C7.0001 6.55239 6.55239 7.0001 6.0001 7.0001H2C1.44771 7.0001 1 6.55239 1 6.0001V2ZM9.00195 2C9.00195 1.44771 9.44967 1 10.002 1H14.0021C14.5543 1 15.0021 1.44772 15.0021 2V6.0001C15.0021 6.55239 14.5543 7.0001 14.0021 7.0001H10.002C9.44967 7.0001 9.00195 6.55239 9.00195 6.0001V2ZM2 8.99976C1.44772 8.99976 1 9.44748 1 9.99976V13.9999C1 14.5522 1.44772 14.9999 2 14.9999H14.0002C14.5525 14.9999 15.0002 14.5522 15.0002 13.9999V9.99976C15.0002 9.44748 14.5525 8.99976 14.0002 8.99976H2Z"
    />
  </svg>
</template>
